import {createSlice} from '@reduxjs/toolkit';
import {logo} from '../assets/images';
import i18n from '../lib/i18n/config';

export const isBrandingAppliedSlice = createSlice({
  name: 'isBrandingApplied',
  initialState: {value: false},
  reducers: {
    updateIsBrandingApplied: (state, action) => {
      state.value = action.payload;
    },
  },
});

export const headerLogoSlice = createSlice({
  name: 'headerLogo',
  initialState: {value: logo},
  reducers: {
    updateHeaderLogo: (state, action) => {
      state.value = action.payload;
    },
  },
});

export const headerLogoAltTextSlice = createSlice({
  name: 'headerLogoAltText',
  initialState: {value: i18n.t('Header.logoAltText')},
  reducers: {
    updateHeaderLogoAltText: (state, action) => {
      state.value = action.payload;
    },
  },
});

export const headerLogoHeadingSlice = createSlice({
  name: 'headerLogoHeading',
  initialState: {value: i18n.t('Header.logoHeading')},
  reducers: {
    updateHeaderLogoHeading: (state, action) => {
      state.value = action.payload;
    },
  },
});

export const footerLeftMarkdownSlice = createSlice({
  name: 'footerLeftMarkdown',
  initialState: {value: '[All Rights Reserved](#)'},
  reducers: {
    updateFooterLeft: (state, action) => {
      state.value = action.payload;
    },
  },
});

export const footerRightMarkdownSlice = createSlice({
  name: 'footerRightMarkdown',
  initialState: {value: '[Copyrighted](#)'},
  reducers: {
    updateFooterRight: (state, action) => {
      state.value = action.payload;
    },
  },
});

export const faviconSlice = createSlice({
  name: 'favicon',
  initialState: {
    faviconValue: 'favicon.ico',
    appleTouchFaviconValue: 'logo192.svg',
  },
  reducers: {
    updateFavicon: (state, action) => {
      state.faviconValue = action.payload;
    },
    updateAppleTouchFaviconValue: (state, action) => {
      state.appleTouchFaviconValue = action.payload;
    },
  },
});
